import template from './sw-cms-block-acris-blog-product-slider.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-blog-product-slider', {
    template
});
